'use strict'

export default {
    product: null,
    variants: [],
    variant: {},

    /**
     * Set the product
     * @param {Object} product
     */
    setProduct(product) {
        this.product = product;
    },

    /**
     * Set the variants
     * @param {Array} variants
     */
    setVariants(variants) {
        this.variants = variants;
    },

    /**
     * Set the current variant
     * @param {String} variant
     */
    setVariant(variant) {
        this.variant = variant;
    },

    /**
     * Get a product from the API by it's SKU code
     * @param {string} sku
     */
    getBySku(sku) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: '/api/products/' + sku,
                headers: {
                    'Accept': 'application/json'
                },
                params: {
                    includes: 'tiers'
                }
            })
            .then(response => {
                resolve(response.data);
            }).catch(errors => {
                reject(errors);
            });
        });
    },

    getRecommended(basket) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: '/api/products/recommended',
                headers: {
                    'Accept': 'application/json'
                },
                params: {
                    includes: 'product',
                    basket_id: basket,
                }
            })
            .then(response => {
                resolve(response.data);
            }).catch(errors => {
                reject(errors);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Services/Product.js